import React from 'react';
import { Link } from 'react-router-dom';
import services from '../data/services';

const Services = () => {
  return (
    <section id="services" className="services-section">
      <div className="services-container">
        <p className="section-tag">OUR SERVICES</p>
        <h2 className="section-heading">What We Offer</h2>
        <p className="services-subtitle">Professional transport solutions available 24/7 across TAXICABS-247 and beyond.</p>
        <div className="services-grid">
          {services.map((s, i) => (
            <div key={i} className="service-card">
              <div className="service-img-wrap">
                <img src={s.image} alt={s.title} />
              </div>
              <div className="service-body">
                <h4><span className="service-dot"></span>{s.title}</h4>
                <p>{s.desc}</p>
                <Link to={`/service-details/${s.slug}`} className="service-btn">{s.title}</Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
